import { trackMetaEvent } from './metaPixel';
import { trackGAEvent } from './googleAnalytics';

/**
 * Regista um clique num link de telefone (`tel:`).
 *
 * Porque existe (15/09/2026): as dez paginas-guia estaticas (`/calculadora`,
 * `/tintas-cin`, `/tinta-para-telhados`, ...) ja' registavam estes cliques com
 * um listener proprio, mas a APP REACT -- que e' a pagina inicial e o miolo do
 * site -- so' disparava o evento de contacto nos tres botoes de WhatsApp. Quem
 * carregasse para ligar a partir da pagina inicial era invisivel no GA4 e no
 * Pixel. E a pagina inicial e' onde chega mais gente.
 *
 * A pergunta que destapou isto, dela: "conseguimos medir do site deles se ha'
 * cliques para ligar para a loja?". A resposta era nao, no sitio que mais conta.
 *
 * ⚠️ Isto NAO mede chamadas, mede CLIQUES no link. Quem veja o numero e marque
 * a' mao, ou ligue do cartaz da montra, continua invisivel -- e e' provavel que
 * seja a maioria. Nao apresentar este numero como "chamadas recebidas".
 *
 * ⚠️ Continua a depender do consentimento de cookies: sem Consent Mode v2, quem
 * recusa ou ignora o banner nao conta em lado nenhum.
 *
 * @param {string} onde  de que sitio da pagina saiu o clique (para segmentar)
 * @param {string} numero  o numero clicado, para distinguir os tres da loja
 */
export function trackCallClick(onde, numero) {
  trackMetaEvent('Contact', { content_name: `Telefone ${onde}` });
  trackGAEvent('contact', { method: 'telefone', onde, numero });
}

/**
 * Clique em "Abrir no Google Maps" / "como chegar".
 *
 * Numa loja fisica este e' dos sinais mais fortes que existem: quem pede
 * direccoes esta' a caminho. Estava invisivel ate' 15/09/2026.
 *
 * `FindLocation` e' o evento padrao do Pixel para isto; no GA4 usa-se o
 * `contact` com method=mapa, para ficar na mesma familia dos outros.
 */
export function trackMapClick(onde) {
  trackMetaEvent('FindLocation', { content_name: `Mapa ${onde}` });
  trackGAEvent('contact', { method: 'mapa', onde });
}

/** Clique no endereco de email. Vale menos que os outros, mas custa o mesmo. */
export function trackEmailClick(onde) {
  trackMetaEvent('Contact', { content_name: `Email ${onde}` });
  trackGAEvent('contact', { method: 'email', onde });
}
